import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AppError } from "@obg/ngx.core";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { TERMS_AND_CONDITIONS_ACTION_TYPE, TermsAndConditionsAction } from "./terms-and-conditions.action";
import { TermsAndConditionsVersion } from "./terms-and-conditions.model";
import { TermsAndConditionsService } from "./terms-and-conditions.service";

@Injectable()
export class TermsAndConditionsEffect {
	getHistory$ = createEffect(() =>
		this.actions$.pipe(
			ofType(TERMS_AND_CONDITIONS_ACTION_TYPE.getHistory),
			switchMap(() =>
				this.termsAndConditionsService.getHistory().pipe(
					map((response) => this.convertAcceptedDateToUtc(response)),
					map((response) => this.termsAndConditionsAction.getHistorySuccess(response)),
					catchError((error: AppError) => of(this.termsAndConditionsAction.getHistoryFail(error)))
				)
			)
		)
	);

	getLatestVersion$ = createEffect(() =>
		this.actions$.pipe(
			ofType(TERMS_AND_CONDITIONS_ACTION_TYPE.getLatestVersion),
			switchMap(() =>
				this.termsAndConditionsService.getLatestVersion().pipe(
					map((response) => this.termsAndConditionsAction.getLatestVersionSuccess(response)),
					catchError((error: AppError) => of(this.termsAndConditionsAction.getLatestVersionFail(error)))
				)
			)
		)
	);

	private convertAcceptedDateToUtc(
		termsAndConditionsDocuments: TermsAndConditionsVersion[]
	): TermsAndConditionsVersion[] {
		termsAndConditionsDocuments.forEach((termsAndConditionsDocument) => {
			const acceptedAtDate = termsAndConditionsDocument.acceptedAt;

			if (!acceptedAtDate) {
				return;
			}

			const FORCE_DATE_TO_UTC = acceptedAtDate.endsWith("Z") ? "" : "Z";

			termsAndConditionsDocument.acceptedAt = acceptedAtDate + FORCE_DATE_TO_UTC;
		});

		return termsAndConditionsDocuments;
	}

	constructor(
		private actions$: Actions,
		private termsAndConditionsAction: TermsAndConditionsAction,
		private termsAndConditionsService: TermsAndConditionsService
	) {}
}
